@if (showAlert) {
    <div class="alert" [ngClass]="extraClass">
        @if (canClose) {
            <span class="closebtn" (click)="showAlert = false">&times;</span>
        }
        @if (isTranslated) {
            <span>{{ text }}</span>
        } @else {
            {{ text | translate }}
        }
    </div>
}
